const ORIGINS = {
  devHelpdeskZurich: 'https://dev-helpdesk.zurich.de',
  testHelpdeskZurich: 'https://test-helpdesk.zurich.de',
  devCustomerportalZurich: 'https://dev.customerportal.zurich.de',
  testCustomerportalZurich: 'https://test.customerportal.zurich.de',
  testCustomerportalZurichSitecore: 'https://uat-germany.jss-uat-de.zurich.com',
  devHelpdeskDa: 'https://dev-helpdesk.da-direkt.de',
  testHelpdeskDa: 'https://test-helpdesk.da-direkt.de',
  devCustomerportalDa: 'https://dev.customerportal.da-direkt.de',
  testCustomerportalDa: 'https://test.customerportal.da-direkt.de',
  prodCustomerportalDa: 'https://customerportal.da-direkt.de',
  prodCustomerportalZurich: 'https://customerportal.zurich.de',
  prodHelpdeskDa: 'https://helpdesk.da-direkt.de',
  prodHelpdeskZurich: 'https://helpdesk.zurich.de'
}

export function getBaseURL() {
  const origin = globalThis.location.origin
  const pathname = globalThis.location.pathname

  const isDacpOrZkpDirectLink =
    origin.includes('dacpwebuidev') ||
    origin.includes('dacpwebuiuat') ||
    origin.includes('zkpwebuidev') ||
    origin.includes('zkpwebuiuat') ||
    origin.includes(ORIGINS.devCustomerportalDa) ||
    origin.includes(ORIGINS.devCustomerportalZurich) ||
    origin.includes(ORIGINS.testCustomerportalDa) ||
    origin.includes(ORIGINS.testCustomerportalZurich) ||
    origin.includes(ORIGINS.prodCustomerportalDa) ||
    origin.includes(ORIGINS.prodCustomerportalZurich) ||
    origin.includes(ORIGINS.prodHelpdeskDa) ||
    origin.includes(ORIGINS.prodHelpdeskZurich)

  const isHelpdesk =
    pathname.includes('helpdesk') ||
    origin.includes('helpdesk') ||
    origin.includes(ORIGINS.devHelpdeskDa) ||
    origin.includes(ORIGINS.devHelpdeskZurich) ||
    origin.includes(ORIGINS.testHelpdeskDa) ||
    origin.includes(ORIGINS.testHelpdeskZurich) ||
    origin.includes(ORIGINS.prodHelpdeskDa) ||
    origin.includes(ORIGINS.prodHelpdeskZurich)

  const isDacpSitecore =
    origin.includes('test.da-direkt.de') ||
    (origin.includes('da-direkt.de') && !origin.includes('.customerportal.'))

  const isZkpSitecore =
    origin.includes(ORIGINS.testCustomerportalZurichSitecore) ||
    origin.includes('main.uat-de.zurich.com') ||
    (origin.includes('zurich.de') && !origin.includes('.customerportal.'))

  if (isDacpOrZkpDirectLink && isHelpdesk) {
    return '/helpdesk'
  } else if (isDacpOrZkpDirectLink && !isHelpdesk) {
    return '/customerportal'
  } else if (isDacpSitecore && !isHelpdesk) {
    return '/meine-da-direkt/da'
  } else if (isZkpSitecore && !isHelpdesk) {
    return '/de-de/meine-zurich/mz'
  } else {
    return '/customerportal'
  }
}
